<template>
  <vi-page>
    <vi-card no-header>
      <VCDataTable v-bind="dtable" @e-row-action="eRowAction" ref="dataTable">
        <template v-slot:table_col_amount="scope">
          <vi-amount v-model="scope.row.amount" :prefix="scope.row.currency.prefix" />
        </template>
        <template #search-append>
          <div class="d-flex align-items-center ml-3">
            <span>订单号：</span>
            <div style="width: 150px">
              <input type="text" class="form-control" placeholder="请输入订单号" v-model="bizNumber" />
            </div>
          </div>
          <div class="d-flex align-items-center ml-3">
            <span>充值状态：</span>
            <div style="width: 150px">
              <vi-selector v-model="paymentOrderStatus" :options="paymentOrderStatusList">
              </vi-selector>
            </div>
          </div>
          <div class="d-flex align-items-center ml-3">
            <div style="width: 150px">
              <button type="reset" class="btn btn-primary" @click="eFilter">
                搜索
              </button>
            </div>
          </div>
        </template>
      </VCDataTable>
    </vi-card>
  </vi-page>
</template>
<script>
import VCDataTable from "@leiweb/kernel-dashboard/src/controls/data/DataTable";
export default {
  name: "PageDashboardShiyuWalletRecharge",
  components: {
    VCDataTable,
  },
  data() {
    return {
      dtable: {
        label: "充值记录",
        url: "/kernel/transaction/apis/biz/user/wallet/recharge/page",
        orderBy: { name: "ID", type: "Desc" },
        params: [],
        fields: [
          {
            name: "sn",
            type: "text",
            label: "订单号",
          },
          {
            name: "time",
            type: "date",
            format: "YYYY-MM-DD HH:mm:ss",
            label: "充值时间",
          },
          { name: "amount", type: "slot", label: "充值金额" },
          {
            name: "paymentName",
            source: "payment.name",
            type: "text",
            label: "充值方式",
          },
          {
            name: "status",
            type: "select",
            label: "充值状态",
            options: [
              { value: "New", label: "新订单" },
              { value: "Pay", label: "待支付" },
              { value: "Paid", label: "已支付" },
              { value: "Done", label: "充值成功" },
              { value: "Canceled", label: "已取消" },
            ],
          },
          {
            name: "currencyPrefix",
            source: "currency.prefix",
            type: "text",
            table: { hidden: true },
          },
        ],
        add: {
          enable: false,
        },
        edit: {
          enable: false,
        },
        rowActions: [{ name: "base", icon: "fas:bars", tips: "详情" }],
      },
      bizNumber: "",
      paymentOrderStatus: "all",
      paymentOrderStatusList: [
        { value: "all", label: "全部" },
        { value: "New", label: "新订单" },
        { value: "Pay", label: "待支付" },
        { value: "Paid", label: "已支付" },
        { value: "Done", label: "充值成功" },
        { value: "Canceled", label: "已取消" },
      ],
      modalData: {
        addable: false,
        showAdd: true,
        sn: "",
      },
      range: [],
      userSN: "",
    };
  },
  mounted() {
    this.oGetUser();
  },
  methods: {
    eRowAction(action, row) {
      if (action.name == "base") {
        this.$$.navigate.to({
          label: `详情[${row.sn}]`,
          path: `/shiyun/wallet/recharge/${row.sn}/detail`,
        });
      }
    },
    eFilter() {
      this.dtable.params = [`userSN == ${this.userSN}`];
      // if (this.paymentOrderStatus == "all") {
      //   this.dtable.params = [`userSN == ${this.userSN}`];
      // }
      
      if (this.paymentOrderStatus && this.paymentOrderStatus != "all") {
        this.dtable.params.push(`status == ${this.paymentOrderStatus}`);
      }

      if (this.bizNumber) {
        this.dtable.params.push(`sn == ${this.bizNumber}`);
        return;
      }
      if (!this.range || this.range.length !== 2) {
        return;
      }

      this.dtable.params.push(`Time >= ${this.range[0]}`);
      if (this.range[0] === this.range[1]) {
        let date = new Date(this.range[0]);
        date = date.setDate(date.getDate() + 1);
        this.dtable.params.push(`Time < ${date}`);
      } else {
        this.dtable.params.push(`Time <= ${this.range[1]}`);
      }
    },
    oGetUser() {
      this.$$.api
        .post("/kernel/authentication/apis/biz/user/current")
        .then((res) => {
          this.dtable.params = {
            userSN: res.data.user.sn,
          };
          this.userSN = res.data.user.sn;
        })
        .catch((e) => {
          this.$$.toastr.error(`错误信息：${e.message}`);
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.bill_select {
  display: flex;
  flex-wrap: wrap;
}

.select_width {
  width: 170px;
}

.date_width {
  width: 200px;
}
</style>
